import SVG from 'react-inlinesvg';
import { StatCardType } from 'helpers/types';
import React from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const StatCard = ({
  title = '',
  value = '0',
  valueUnit = '',
  color = '',
  svg = '',
  percentage = '',
  tooltipText = '',
  children = null,
}: StatCardType) => {
  return (
    <div className={`statcard card-bg-${color} text-white py-3 px-4 mb-spacer rounded`}>
      <div className="d-flex align-items-center justify-content-between mt-1 mb-2">
        {svg !== '' ? (
          <div className="icon my-1 fill-white" style={{ paddingBottom: '1px' }}>
            <SVG src={process.env.PUBLIC_URL + '/' + svg} className="text-white"></SVG>
          </div>
        ) : null}
        <div>{children}</div>
      </div>
      <span>{title}</span>
      <p className="h5 mb-0">
        {value} {valueUnit}
      </p>
      <small>
        {percentage}
        {tooltipText !== '' && (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={props => (
              <Tooltip id="button-tooltip" {...props}>
                {tooltipText}
              </Tooltip>
            )}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="ml-1" />
          </OverlayTrigger>
        )}
      </small>
    </div>
  );
};

export default StatCard;
